export enum InputContentType {
    NONE = 'none',
    PATCH_BATS_PLAYER_ATTRIBUTES = 'patch_bats_player_attributes',
    PATCH_EVENT = 'patch_event',
    PATCH_EVENT_SERIES = 'patch_event_series',
    PATCH_PLAYER = 'patch_player',
    PATCH_PLAYER_FAMILY_RELATIONSHIPS = 'patch_player_family_relationships',
    PATCH_BATS_SCOREKEEPING_DATA = 'patch_bats_scorekeeping_data',
    PATCH_BATS_STARTING_LINEUP = 'patch_bats_starting_lineup',
    PATCH_TEAM = 'patch_team',
    PATCH_OPPONENT_TEAM = 'patch_opponent_team',
    POST_CLIENT_AUTHENTICATE = 'post_client_authenticate',
    POST_BATS_PLAYER_ATTRIBUTES = 'post_bats_player_attributes',
    POST_BATS_SCOREKEEPING_DATA = 'post_bats_scorekeeping_data',
    POST_BATS_SCOREKEEPING_EVENT = 'post_bats_scorekeeping_event',
    POST_BATS_STARTING_LINEUP = 'post_bats_starting_lineup',
    POST_PREGAME_DATA = 'post_pregame_data',
    POST_EVENT = 'post_event',
    POST_EVENT_SERIES = 'post_event_series',
    POST_FIREBASE_TOKEN = 'post_firebase_token',
    POST_PLAYER = 'post_player',
    POST_TEAM = 'post_team',
    POST_MAXPREPS_TEAM_IMPORT = 'post_maxpreps_team_import',
    POST_OPPONENT_TEAM = 'post_opponent_team',
    POST_OPPONENT_TEAM_IMPORT = 'post_opponent_team_import',
    POST_OPPONENT_TEAM_LEGACY_IMPORT = 'post_opponent_team_legacy_import',
    POST_TEAM_INVITE_RESEND = 'post_team_invite_resend',
    POST_TEAM_AVATAR_IMAGE = 'post_team_avatar_image',
    POST_TEAM_HIGH_SCHOOL_INFO = 'post_team_high_school_info',
    POST_TEAM_IMPORT = 'post_team_import',
    POST_USER = 'post_user',
    POST_USER_AUTHENTICATE = 'post_user_authenticate',
    PUT_TEAM_MANAGER = 'put_manager',
    POST_USER_AUTHENTICATE_FROM_TOKEN = 'post_user_authenticate_from_token',
    POST_AUTHENTICATION_PROVIDER_AUTHENTICATE = 'post_authentication_provider_authenticate',
    POST_LOGIN_LINK = 'post_login_link',
    PUT_RSVP_RESPONSE = 'put_rsvp_response',
    PATCH_PASSWORD = 'patch_password',
    POST_MESSAGING_CHANNEL_IMAGE = 'post_messaging_channel_image',
    POST_MESSAGING_CHANNEL_VIDEO = 'post_messaging_channel_video',
    POST_REIMPORT_EXTERNAL_EVENTS = 'post_reimport_external_events',

    PUT_GAME_STAT_EDIT_COLLECTION = 'put_game_stat_edit_collection',

    POST_SIMPLE_SCOREKEEPING_TEAM_CONFIG = 'post_simple_scorekeeping_team_config',

    POST_SIMPLE_SCOREKEEPING_GAME_DATA = 'post_simple_scorekeeping_game_data',
    PATCH_SIMPLE_SCOREKEEPING_GAME_DATA = 'patch_simple_scorekeeping_game_data',
    POST_SIMPLE_SCOREKEEPING_GAME_DATA_AFTER_GAME = 'post_simple_scorekeeping_game_data_after_game',
    PATCH_SIMPLE_SCOREKEEPING_GAME_DATA_AFTER_GAME = 'patch_simple_scorekeeping_game_data_after_game',
    POST_SIMPLE_SCOREKEEPING_GAME_TIME = 'post_simple_scorekeeping_game_time',

    PATCH_TEAM_NOTIFICATION_SETTING = 'patch_team_notification_setting',

    PATCH_ROSTER_ROLLOVER = 'patch_roster_rollover',

    PATCH_ORGANIZATION_SCHEDULE_EVENT = 'patch_organization_schedule_event',
    POST_ORGANIZATION_SCHEDULE_EVENT = 'post_organization_schedule_event',
    POST_ORGANIZATION_SCHEDULE_EVENT_BULK = 'post_organization_schedule_event_bulk',
    POST_ORGANIZATION_SCHEDULE_EVENT_BULK_VALIDATE = 'post_organization_schedule_event_bulk_validate',
    POST_ORGANIZATION_TEAMS = 'post_organization_teams',

    PATCH_STREAM_ASSET_METADATA = 'patch_stream_asset_metadata',
    POST_TEAM_COMMUNITY_PASS = 'post_team_community_pass',
}

export enum OutputContentType {
    NONE = 'none',
    BATS_IMPORT_INITIATE = 'bats_import_initiate',
    BATS_PLAYER_ATTRIBUTES = 'bats_player_attributes',
    BATS_SCOREKEEPING_DATA = 'bats_scorekeeping_data',
    BATS_SCOREKEEPING_EVENT = 'bats_scorekeeping_event',
    BATS_SCOREKEEPING_EVENT_ID = 'bats_scorekeeping_event_id',
    BATS_USER = 'bats_user',
    PREGAME_DATA = 'pregame_data',
    CLIENT_TOKEN = 'client_token',
    CLIENT_BACKUP = 'client_backup',
    EVENT = 'event',
    EVENT_SERIES = 'event_series',
    FIREBASE_TOKEN = 'firebase_token',
    PERMISSION = 'permission',
    ENTITY_PERMISSION = 'entity_permission',
    SCOPED_PERMISSIONS = 'scoped_permissions',
    PLAYER = 'player',
    PUBLIC_TEAM = 'public_team',
    PUBLIC_TEAM_SUMMARY = 'public_team_summary',
    RSVP_RESPONSE = 'rsvp_response',
    SUBSCRIPTION_INFORMATION = 'subscription_information',
    SYNC_CHANNEL_STATE = 'sync_channel_state',
    SYNC_UPDATE = 'sync_update',
    GLBOAL_SYNC_UPDATE = 'global_sync_update',
    TEAM_SEASON_STATS = 'team_season_stats',
    PLAYER_STATS = 'player_stats',
    PLAYER_GAME_STATS = 'player_game_stats',
    TEAM = 'team',
    TEAM_FAN = 'team_fan',
    OPPONENT_TEAM = 'opponent_team',
    OPPONENT_TEAM_ID = 'opponent_team_id',
    TEAM_ID = 'team_id',
    TEAM_INVITE_RESEND = 'team_invite_resend',
    TEAM_MESSAGING_CHANNEL = 'team_messaging_channel',
    TEAM_AVATAR_IMAGE = 'team_avatar_image',
    TEAM_HIGH_SCHOOL_INFO = 'team_high_school_info',
    TWILIO_CHAT_TOKEN = 'twilio_chat_token',
    USER = 'user',
    USER_TOKEN = 'user_token',
    USER_STATUS = 'user_status',
    EXTERNAL_CALENDAR_SYNC_URL = 'external_calendar_sync_url',
    MESSAGING_CHANNEL_IMAGE = 'messaging_channel_image',
    MESSAGING_CHANNEL_VIDEO = 'messaging_channel_video',
    LOGIN_LINK = 'login_link',
    TEAM_EXTERNAL_ASSOCIATIONS = 'team_external_associations',
    REIMPORT_EXTERNAL_EVENTS = 'reimport_external_events',

    SIMPLE_SCOREKEEPING_CONFIG = 'simple_scorekeeping_config',

    SIMPLE_SCOREKEEPING_TEAM_CONFIG = 'simple_scorekeeping_team_config',

    SIMPLE_SCOREKEEPING_GAME_DATA = 'simple_scorekeeping_game_data',
    BATCH_SIMPLE_SCOREKEEPING_GAME_DATA_RESULT = 'batch_simple_scorekeeping_game_data_result',
    GAME_SUMMARY = 'game_summary',

    TEAM_NOTIFICATION_SETTING = 'team_notification_setting',

    TEAM_SEARCH_RESULT = 'team_search_results',
    OPPONENT_TEAM_IMPORT_SEARCH_RESULT = 'opponent_team_import_search_results',
    MAXPREPS_SCHOOL_SEARCH_RESULTS = 'maxpreps_school_search_results',
    MAXPREPS_IMPORT_RESULT = 'maxpreps_import_result',

    INTEGRATIONS_LITE_TEAM = 'integrations_lite_team',
    RELATIONSHIP_REQUEST = 'relationship_request',
    USER_TEAM_ASSOCIATIONS = 'team_associations',
    USER_PLAYER_RELATIONSHIP = 'user_player_relationship',
    TEAM_USER = 'team_user',

    EVENT_BEST_STREAM_ID = 'game_stream_id',
    GAME_STREAM = 'game_stream',
    GAME_STREAM_EVENT = 'game_stream_event',
    GAME_STREAM_VIEWER_PAYLOAD_LITE = 'game_stream_viewer_payload_lite',
    BATS_STARTING_LINEUP = 'bats_starting_lineup',
    LATEST_BATS_STARTING_LINEUP = 'latest_bats_starting_lineup',

    GAME_STAT_EDIT_COLLECTION = 'game_stat_edit_collection',

    SCHEDULE_EVENT_VIDEO_STREAM = 'schedule_event_video_stream',

    ORGANIZATION_WITH_ROLE = 'organization_with_role',
    ORGANIZATION = 'organization',
    ORGANIZATION_TEAM = 'organization_team',
    ORGANIZATION_USER_ASSOCIATIONS = 'user_organization_associations',
    ORGANIZATION_SCHEDULE_EVENT = 'organization_schedule_event',
    ORGANIZATION_SCHEDULE_EVENT_BULK_UPLOAD_TEMPLATE = 'organization_schedule_event_bulk_upload_template',
    ORGANIZATION_SCHEDULE_EVENT_BULK_VALIDATE = 'organization_schedule_event_bulk_validate',
    ORGANIZATION_LEADERBOARDS = 'organization_leaderboards',
    ORGANIZATION_SCHEDULE_EVENT_RESULTS_EXPORT = 'organization_schedule_event_results_export',

    VIDEO_CLIP_ASSET_METADATA = 'video_clip_asset_metadata',
    VIDEO_CLIP = 'video_clip',
    VIDEO_STREAM_ASSET_METADATA = 'video_stream_asset_metadata',
    VIDEO_STREAM_ASSET_PLAYBACK_DATA = 'video_stream_asset_playback_data',
    VIDEO_STREAM_PLAYBACK_DATA = 'video_stream_playback_data',
    ATHLETE_PROFILE_PUBLIC = 'athlete_profile_public',
    ATHLETE_PROFILE_CLIPS_PUBLIC = 'athlete_profile_clips_public',
    ATHLETE_PROFILE_CAREER_STATS_PUBLIC = 'athlete_profile_career_stats',
    PUBLIC_TEAM_PROFILE = 'public_team_profile',
    TEAM_PUBLIC_PROFILE_ID = 'team_public_profile_id',
}

export class ListContentType<ContentType extends InputContentType | OutputContentType> {
    public type: ContentType;
    public isList = true;

    constructor(baseContentType: ContentType) {
        this.type = baseContentType;
    }

    public toString(): string {
        return `${this.type}:list`;
    }
}
